import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { IconChevronsLeft, IconChevronLeft, IconChevronRight, IconChevronsRight } from "@tabler/icons-react";
import { LangConstant } from "const";
import { SERVICE_ID } from "const/system.const";

const Datatable = ({ conferences, pagination, onChangePage, onViewDetails, onViewConfig }) => {
  const { t: getLabel } = useTranslation();

  return (
    <Fragment>
      <div className="table-responsive" style={{ marginTop: 16, marginBottom: 16 }}>
        <table className="table table-vcenter" style={{ whiteSpace: "nowrap", tableLayout: "fixed", minWidth: 650 }}>
          <thead>
            <tr>
              <th style={{ width: "30%", fontWeight: "bold" }}>{getLabel("TXT_APPLICATION_NAME")}</th>
              <th style={{ width: "45%", fontWeight: "bold" }}>{getLabel("TXT_DESCRIPTION")}</th>
              <th style={{ width: "15%", fontWeight: "bold" }}>{getLabel("TXT_ADMINISTRATOR")}</th>
              <th style={{ width: "15%", fontWeight: "bold" }}>{getLabel("TXT_ACTION")}</th>
            </tr>
          </thead>
          <tbody>
            {conferences.length > 0 ? (
              conferences.map((app, index) => {
                const isConferenceService = app.serviceId === SERVICE_ID.conference;

                return (
                  <tr key={index}>
                    <td
                      style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                      title={app.name}
                    >
                      {app.name}
                    </td>
                    <td
                      style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                      title={app.description}
                    >
                      {app.description}
                    </td>
                    <td style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {isConferenceService && (
                        <span
                          style={{ color: "#007BFF", cursor: "pointer" }}
                          title={app.adminAccountIds?.length || getLabel(LangConstant.L_ADD_BUTTON)}
                          onClick={() => onViewDetails(app)}
                          onMouseOver={e => (e.target.style.textDecoration = "underline")}
                          onMouseOut={e => (e.target.style.textDecoration = "none")}
                        >
                          {getLabel("TXT_VIEW_DETAIL")}
                        </span>
                      )}
                    </td>
                    <td style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {isConferenceService && (
                        <span
                          style={{ color: "#007BFF", cursor: "pointer" }}
                          onClick={() => onViewConfig(app)}
                          onMouseOver={e => (e.target.style.textDecoration = "underline")}
                          onMouseOut={e => (e.target.style.textDecoration = "none")}
                        >
                          {getLabel("TXT_CONFIG_APP")}
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  <small>
                    <i>{getLabel(LangConstant.TXT_NOT_FOUND)}</i>
                  </small>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {pagination.total > 1 && (
        <div className="d-flex align-items-center justify-content-end" style={{ margin: "24px 0" }}>
          <ul className="pagination">
            <li className={`page-item ${pagination.current <= 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={e => onChangePage(e, 1)}>
                <IconChevronsLeft size={16} />
              </button>
            </li>
            <li className={`page-item ${pagination.current <= 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={e => onChangePage(e, pagination.current - 1)}>
                <IconChevronLeft size={16} />
              </button>
            </li>
            <li className="page-item active">
              <span className="page-link">{pagination.current}</span>
            </li>
            <li className={`page-item ${pagination.current >= pagination.total ? "disabled" : ""}`}>
              <button className="page-link" onClick={e => onChangePage(e, pagination.current + 1)}>
                <IconChevronRight size={16} />
              </button>
            </li>
            <li className={`page-item ${pagination.current >= pagination.total ? "disabled" : ""}`}>
              <button className="page-link" onClick={e => onChangePage(e, pagination.total)}>
                <IconChevronsRight size={16} />
              </button>
            </li>
          </ul>
        </div>
      )}
    </Fragment>
  );
};

export default Datatable;
